<template>
  <div class="my-4 grid gap-8 max-w-7xl" v-if="block?.data?.restaurants?.length">
    <AtomBlockHeader v-if="block.data?.title || block.data?.excerpt"
      :heading="block.data?.title"
      :leading="block.data?.excerpt"
    />
    <div class="grid gap-8">
      <BlocksRestaurantReviewsStandard v-if="block.data.layout === 'standard'" :restaurants="block.data?.restaurants" />
      <BlocksRestaurantReviewsFeatured v-if="block.data.layout === 'featured'" :restaurants="block.data?.restaurants" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})
</script>
